import { Button, ConfigProvider, Divider, Flex, Input, Typography } from 'antd';
import PropTypes from 'prop-types';
import './MapFilter.css';
import { ReactComponent as SelectDropdownBlackSvg } from '../../assets/icons/select-dropdown-black.svg';
import { ReactComponent as SearchBlack } from '../../assets/icons/search-black.svg';
import Icon from '@ant-design/icons';
import { useEffect, useState } from 'react';
import { sanitizeInput } from '../../utilities/commonFunctions';
import EmptyCard from '../EmptyCard/EmptyCard';
import { ReactComponent as NoDataWhiteSvg } from '../../assets/no-data-white.svg';

const { Text } = Typography;

const MapFilter = ({ mapFilterList = [], title, onChange }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [filteredList, setFilteredList] = useState(mapFilterList);
  const [selectedFilter, setSelectedFilter] = useState('');

  const toggleExpand = () => {
    setIsExpanded(prev => !prev);
  };

  const handleFilter = value => {
    const filtered = mapFilterList.filter(item =>
      item?.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredList(filtered);
  };

  const onSearchTextChange = e => {
    setSearchText(sanitizeInput(e.target.value));
  };

  useEffect(() => {
    handleFilter(searchText);
  }, [searchText]);

  useEffect(() => {
    if (!searchText) {
      setFilteredList(mapFilterList);
    } else {
      handleFilter(searchText);
    }
  }, [mapFilterList]);

  const handleSelectChange = item => {
    setSelectedFilter(item);
    onChange?.(item);
  };

  const handleClear = () => {
    setSelectedFilter('');
    setSearchText('');
    onChange?.('');
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          Input: {
            colorBgContainer: '#D0D4D8',
            colorText: '#000000',
          },
        },
      }}
    >
      <Flex className="map-filter-container" wrap="wrap">
        <Flex
          className="map-filter-header"
          justify="space-between"
          onClick={toggleExpand}
        >
          <Text style={{ color: '#000000' }}>{title}</Text>
          <Icon
            component={SelectDropdownBlackSvg}
            rotate={isExpanded ? 180 : 0}
          />
        </Flex>
        {isExpanded && (
          <>
            {mapFilterList?.length !== 0 && (
              <Input
                onChange={onSearchTextChange}
                value={searchText}
                size="large"
                placeholder="what are you searching for?"
                suffix={<Icon component={SearchBlack} width={20} height={20} />}
                className="input-search tripslist-search"
                // disabled={loading}
              />
            )}

            {mapFilterList?.length !== 0 && (
              <Flex justify="end" className="full-width">
                <Button
                  type="link"
                  className="btn-login-link"
                  onClick={handleClear}
                >
                  Clear selection
                </Button>
              </Flex>
            )}

            {filteredList?.length === 0 ? (
              <EmptyCard
                description={`No ${title} Found`}
                image={<Icon component={NoDataWhiteSvg} />}
              />
            ) : (
              <Flex
                style={{
                  overflowY: 'auto',
                  maxHeight: 'calc(100vh - 420px)',
                  width: '100%',
                }}
                vertical
              >
                {filteredList?.map((item, index) => (
                  <Flex
                    key={index}
                    vertical
                    style={{
                      backgroundColor:
                        selectedFilter === item ? '#56B0FF' : '#EFF1F2',
                    }}
                    onClick={() => handleSelectChange(item)}
                  >
                    <Text style={{ color: '#000000', padding: '12px 16px' }}>
                      {item}
                    </Text>
                    <Divider />
                  </Flex>
                ))}
              </Flex>
            )}
          </>
        )}
      </Flex>
    </ConfigProvider>
  );
};

MapFilter.propTypes = {
  mapFilterList: PropTypes.array,
  title: PropTypes.string,
  onChange: PropTypes.func,
};

export default MapFilter;
